export default __webpack_public_path__ + "static/media/gallery_03.ff8d947f.jpg";